import { useEffect } from "react";
import { useAppDispatch } from "redux/hooks";
import {
  registerReferenceCar,
  registerReferenceElectricGridCountry,
  registerReferenceTripTravelMode,
} from "redux/slices/shed/shedSlice";
import { getGlobalCars } from "hooks/cars/useGlobalCars";
import { getElectricGridCountryFromTimezone } from "libraries/electricGridFromTimezone";
import { first } from "lodash/fp";
import { TravelMode } from "types/map";

/** Map defaults for `/h/map` — global car fleet + timezone-based EV grid. */
const useFranceRentalMapInit = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      registerReferenceElectricGridCountry(
        getElectricGridCountryFromTimezone()
      )
    );
    dispatch(registerReferenceTripTravelMode(TravelMode.DRIVING));

    const defaultCar = first(getGlobalCars());
    defaultCar && dispatch(registerReferenceCar(defaultCar));
  }, [dispatch]);
};

export default useFranceRentalMapInit;
